export default {
  listTitle: 'ファームウェア管理 / 一括アップデート一覧',
  formTitle: 'ファームウェア管理 / 一括アップデート',
  operationOffice: '運営会社',
  deviceType: '型番',
  firmware: 'FWバージョン',
  createBtn: '新規作成',
  tooltip: {
    authority: '削除する権限がありません。',
  },
  targetDevice:{
    name: '対象デバイス',
    category: '対象カテゴリー',
    selectCategory: '対象カテゴリーを選択してください',
  },
  applyDate:{
    name: '適用開始日',
  },
  firmwareVirsion:{
    name: '適用FWバージョン',
  },
  versionNote:{
    name: 'メモ',
  },
  firmwareBlukUpdateSettings:{
    tableHeader: {
      id: 'ID',
      applyDate: '適用開始日',
      firmwareVersion: '適用バージョン',
      nunberOfApplyDevices: '適用デバイス数',
      numberOfRemovedDevices: '除外デバイス数',
      updatedAt: '最終更新時刻',
      updatedBy: '最終更新者',
      detailBtn: '詳細',
      deleteBtn: '削除',
    },
  },
  removeDeviceSearch:{
    name: '除外デバイス検索',
    result: '検索結果',
    removeDevice: '除外デバイス',
    tableHeader: {
      operationOffice: '運営会社',
      deviceId: 'デバイスID',
      vehicleNumber: '車両番号',
      deviceType: '型番',
    },
  },
  btn:{
    apply: '適用',
    cancel: 'キャンセル',
  },
  messages:{
    validSelect: '選択してください',
    validGetList: '一覧の読み込みに失敗しました',
  }
}
